<template>
  <div>
    <BusinessIndex v-if="showsBusinessIndex"/>
    <PrivateIndex v-else />
  </div>
</template>
<script>
import PrivateIndex from '~/pages/privateIndex'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Home',
  layout: 'default',
  components: {
    PrivateIndex,
    BusinessIndex: () => import('~/pages/businessIndex') /* webpackChunkName "BusinessIndex" */
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn']),
    showsBusinessIndex() {
      return this.isLoggedIn && this.user.isBusiness
    }
  }
}
</script>
